import { useState, useEffect } from 'react';
import { apiFetch } from '../utils/api';

export const useSeats = (searchParams: Record<string, string>, page: number, refreshIndex: number) => {
  const [seats, setSeats] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchSeats = async () => {
      try {
        const backendUrl = process.env.REACT_APP_API_URL;
        if (!backendUrl) throw new Error('Backend URL is not defined');

        const query = new URLSearchParams({ page: page.toString(), ...searchParams }).toString();
        const res = await apiFetch(`${backendUrl}/seats?${query}`);

        const sortedSeats = res.data.sort((a: any, b: any) => {
          if (a.fila === b.fila) return a.numero - b.numero;
          return a.fila.localeCompare(b.fila);
        });

        setSeats(sortedSeats);
        setTotalPages(res.totalPages);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSeats();
  }, [searchParams, page, refreshIndex]);

  return { seats, totalPages };
};
